import { render, staticRenderFns } from "./veStuMoralProgramAdmin.vue?vue&type=template&id=1278e4b4&scoped=true"
import script from "./veStuMoralProgramAdmin.vue?vue&type=script&lang=js"
export * from "./veStuMoralProgramAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278e4b4",
  null
  
)

export default component.exports